import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Select, TextField, Typography, Grid, FormControlLabel, Button } from "@mui/material";


export const FormContainer = styled("form")`
    display: grid;
`;

export const QuestionField = styled("div")`
    text-align: center;
`;

export const InputField = styled("input")`
    color: black;
`;

export const ButtonContainer = styled("div")`
    padding-top: 1em;
    display: grid;
    float: right;
    grid-auto-flow: column;
    grid-column-gap: 1em;
    height: 20%;
    padding-bottom: 1em;
`;

export const DomainHeader = styled("section")`
    text-align: center;
    font-size: xx-large;
    font-weight: 800;
    padding-top: 1em;
`;

export const BackButton = styled("button")`
    height: 2em;
    color: #A100FF;
    background-color: transparent;
    border-radius: 20px;
    width: 6em;
    margin-left: auto;
    position: relative;
    top: .3em;
    border: 1px solid grey;
    margin-right: 1em;
    font-weight: 600;

    &:hover {
        border: 1px solid grey;
  }
`;


export const NextButton = styled("button")`
    height: 2.5em;
    color: white;
    background-color: #A100FF;
    border-radius: 20px;
    width: 7em;
    margin-left: auto;
`;

export const DownloadButton = styled("button")`
    height: 2.5em;
    color: white;
    background-color: #A100FF;
    border-radius: 20px;
    width: 13em;
    margin-top: auto;
`;


export const QuestionContainer = styled("div")`
    background: white;
    margin-top: 1em;
    border-radius: 1em;
    padding: 1em 2em 2em 2em;

`;

export const Question = styled("div")`
    font-weight: 600;
    font-size: large;
    padding-bottom: 1em;
`;

export const FormatLabel = styled("div")`
    font-weight: 600;
    padding-bottom: 1em;
`;

export const FormatSelect = styled("select")`
    border-style: solid;
    border-color: black;
    border-width: 1px;
    height: 2em;
    width: 43%;
`;

export const DomainTab = styled("button")`
    border-radius: 2px;
    overflow: visible
`;

export const DomainTabs = styled("div")`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

export const DomainContainer = styled("div")`
    margin-right: 2em;
    margin-top: 1em;
    max-height: 42px;
    display: flex;
`;

export const DomainContainerActive = styled("div")`
    border-bottom: 3px solid #A100FF;
    font-weight: 600;
    margin-right: 2em;
    margin-top: 1em;
    max-height: 42px;
    display: flex;
`;

export const ProgressMessage = styled("div")`
    padding-left: 1em;
    margin-top: 3em;
    color: #6A6A6A;
`;



export const HeaderContainer = styled("div")`
    display: flex;
`;

export const Divider = styled("div")`
    border-left: 2px solid lightgrey;
`;

export const OfflineDownloadContainer = styled("div")`
    display: flex;
    width: 50%;
    padding: 0.25em 0em 0em 3em;
    flex-direction: column
`;

export const OfflineDownloadQuestion = styled("div")`
    font-style: italic;
    color: #1D1D1D
`;